import axios from "axios";
import { API_BASE_URL } from "../environment";

export const getAadharServiceLogs = async (filters = {}) => {
  const params = Object.fromEntries(
    Object.entries(filters).filter(
      ([, value]) => value !== undefined && value !== null && value !== ""
    )
  );
  const response = await axios.get(`${API_BASE_URL}/service_logs`, { params });
  return response.data;
};
